<button class="{{ additionalClass }}" [ngClass]="dynamicClass" mat-menu-item [attr.style]="styles" [disabled]="!!disabled" (click)="trackButton()">
  @if (matIcon) {
    <mat-icon>{{ matIcon }}</mat-icon>
  }
  <ng-content></ng-content>
</button>
